import React, { useState, useEffect } from 'react'
import moment from 'moment'
import rightArrow from '../../../assets/images/icon-right-arrow.png'
import leftArrow from '../../../assets/images/icon-left-arrow.png'
import PaginatorComponent from '../../Pagination/PaginatorComponent'
import { getAllotmentColorClass } from './allotmentUtils'
import { useTranslation } from 'react-i18next'
import Slider from "react-slick";
import { CommonDropDown } from '../../../common/Resusable/CommonDropDown'
const AllotmentList = ({ allotmentValType, allotmentList, setIsLoading }) => {
	const { t } = useTranslation(['labels', 'errors'])
	const [translateX, setTranslateX] = useState(0)
	const [index, setIndex] = useState(0)

	const [pageIndex, setPageIndex] = useState(1)
	const [currentPage, setCurrentPage] = useState(0)
	const [startIndex, setStartIndex] = useState(0)
	const [endIndex, setEndIndex] = useState(0)
	const [totalRecordCount, setTotalRecordCount] = useState(0)

	const [customWidth, setcustomWidth]   = useState(window.innerWidth);
	const [disableButton, setDisableButton] = useState(false);

	const rowCount = 5

	const today = moment()

	const [selectedAllotment, setSelectedAllotment] = useState(null);

	useEffect(() => {
	if (allotmentList && allotmentList.length > 0) {
	setSelectedAllotment(allotmentList[0]);
	}
	}, [allotmentList]);

	const updateDimensions = () => {
		setcustomWidth(window.innerWidth);
	}

	useEffect(() => {
		window.addEventListener("resize", updateDimensions);
		return () => window.removeEventListener("resize", updateDimensions);
	}, []);

	useEffect(() => {
		setTranslateX(0)
		setIndex(0)
	}, [customWidth])
	
	useEffect(() => {
		onPageIndexChange(pageIndex)
	})
	useEffect(() => {
		const maxIndex = 14 - 4;
		if (index >= maxIndex) {
			setDisableButton(true)
		} else {
			setDisableButton(false)
		}
	}, [index])

	// const handleNext = () => {
	// 	if (index === 0) {
	// 		if(customWidth <= 768) {
	// 			setTranslateX(translateX - 33.33)
	// 		} else {
	// 			setTranslateX(translateX - 13)
	// 		}
	// 	} else {
	// 		if(customWidth <= 768) {
	// 			setTranslateX(translateX - 33.33)
	// 		} else {
	// 			setTranslateX(translateX - 13)
	// 		}
	// 	}
	// 	setIndex(index + 1)
	// }

	// const handlePrev = () => {
	// 	if (index === 1) {
	// 		if(customWidth <= 768) {
	// 			setTranslateX(translateX + 33.33)
	// 		} else {
	// 			setTranslateX(translateX + 13)
	// 		}
	// 	} else {
	// 		if(customWidth <= 768) {
	// 			setTranslateX(translateX + 33.33)
	// 		} else {
	// 			setTranslateX(translateX + 13)
	// 		}
	// 	}
	// 	setIndex(index - 1)
	// }

	const handleNext = () => {
	const maxIndex = calendarDates.length - 4;
	if (index < maxIndex) {
		setIndex(index + 1);
	}
		};

		const handlePrev = () => {
			if (index > 0) {
				setIndex(index - 1);
			}
		};


	const calendarStyles = {
		transform: `translateX(${translateX}%)`,
	}

	const getCalendarDate = (index) => {
		var date = moment(today).add(index, 'days')
		return date.format('DD MMM')
	}

	const setDates = () => {
		let cards = []

		for (let i = 0; i < 14; i++) {
			cards.push(getCalendarDate(i))
		}
		return cards
	}

	const getAllotmentsForDates = (index, item, allotmentId, altIndex) => {
		let cards = []

		for (let i = index; i < 14; i++) {
			if (
				item &&
				item.flightDepartureDate &&
				moment(item.flightDepartureDate).format('DD MMM') === getCalendarDate(i)
			) {
				cards.push(
					<div className='table__body-td calendar-col'>
						{allotmentValType && allotmentValType === 'allotment-actual' ? (
							item.allotmentPercentVolume &&
							item.allotmentPercentVolume > item.allotmentPercentWeight ? (
								<span
									className={`${getAllotmentColorClass(
										item.allotmentPercentVolume
									)} ${getActiveColClassFn(i)}`}
								>
									{item.bookedVolume} CBM
								</span>
							) : (
								<span
									className={`${getAllotmentColorClass(
										item.allotmentPercentWeight
									)} ${getActiveColClassFn(i)}`}
								>
									{item.bookedWeight} Kg
								</span>
							)
						) : item.allotmentPercentVolume &&
						  item.allotmentPercentVolume > item.allotmentPercentWeight ? (
							<span
								className={`${getAllotmentColorClass(
									item.allotmentPercentVolume
								)} ${getActiveColClassFn(i)}`}
							>
								{item.allotmentPercentVolume}%
							</span>
						) : (
							<span
								className={`${getAllotmentColorClass(
									item.allotmentPercentWeight
								)} ${getActiveColClassFn(i)}`}
							>
								{item.allotmentPercentWeight}%
							</span>
						)}
					</div>
				)
				break
			} else if (
				(index !== 0 &&
					allotmentList[altIndex]?.allotments[index - 1] &&
					allotmentList[altIndex]?.allotments[index - 1].flightDepartureDate &&
					moment(
						allotmentList[altIndex].allotments[index - 1].flightDepartureDate
					).format('DD MMM') !== getCalendarDate(i) &&
					moment(
						allotmentList[altIndex].allotments[index - 1].flightDepartureDate
					)
						.add(1, 'days')
						.format('DD MMM') !==
						moment(item.flightDepartureDate).format('DD MMM')) ||
				index === 0
			) {
				cards.push(
					<div className='table__body-td calendar-col'>
						<span className={`${getActiveColClassFn(i)}`}></span>
					</div>
				)
			}
		}
		return cards
	}

	const [calendarDates, setCalendarDates] = useState(setDates())

	const onPageIndexChange = (newPageIndex, currentPage) => {
		setPageIndex(newPageIndex)
		setCurrentPage(currentPage)
		setStartIndex((newPageIndex - 1) * rowCount)
		if(customWidth <=992) {
			setEndIndex(allotmentList.length)
		} else {
			setEndIndex((newPageIndex - 1) * rowCount + rowCount)
		}
	}

	const getActiveColClass = (itemIndex) => {
		return itemIndex >= index && itemIndex < index + 7 ? 'active' : 'inactive'
	}

	const getActiveColClassFn = (itemIndex) => {
		return itemIndex > index && itemIndex < index + 7 ? 'active' : 'inactive'
	}

	function SampleNextArrow(props) {
		const { className, style, onClick } = props;
		return (
		  <img
			src={rightArrow}
			className={className}
			alt='Previous'
			onClick={onClick}
		/>
		);
	  }
	  
	  function SamplePrevArrow(props) {
		const { className, style, onClick } = props;
		return (
			<img src={leftArrow} className={className} alt='Next' onClick={onClick} />
		);
	  }
	  
	const settings = {
		className: "center",
		infinite: false,
		centerPadding: "60px",
		slidesToShow: 3,
		swipeToSlide: true,
		nextArrow: <SampleNextArrow />,
		prevArrow: <SamplePrevArrow />,
		afterChange: function(index) {
		  console.log(
			`Slider Changed to: ${index + 1}, background: #222; color: #bada55`
		  );
		}
	  };

				const handleChange = (e) => {
			const selected = allotmentList.find(a => a.allotmentId === e.target.value);
			setSelectedAllotment(selected);
			};

		const allotmentOptions = allotmentList?.map(item => ({
		label: item.allotmentId,
		value: item.allotmentId
		}));

			const todays = moment();

			const getCalendarDateMobile = (index, startDate) => {
			const date = moment(startDate).add(index, 'days');
			return date.format('DD MMM');
			};

			const setDatesMobile = () => {
			const startOfWeek = moment(todays).startOf('isoWeek'); 
			const cards = [];

			for (let i = 0; i < 21; i++) {
			cards.push(getCalendarDateMobile(i, startOfWeek));
			}

			return cards;
			};


		const [calendarDatesMobile, setCalendarDatesMobile] = useState(setDatesMobile());
		const weekDayArray = (arr, size) =>
				Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
				arr.slice(i * size, i * size + size)
				);
		const weeks = weekDayArray(calendarDatesMobile, 7);
	return (
		<>

		<div class="table-container-allotments d-none d-lg-flex">
			
			<div class="left-section">
			<table class="left-table">
			<thead>
			<tr>
				<th className='header-cell-allotment allotment-box'>{t('DASHBOARD.ALLMNT_ID')}</th>
				<th className='header-cell-allotment orgin-des-box'>{t('DASHBOARD.ORG_DEST_ALLOTMENT')}</th>
				<th className='header-cell-allotment flight-leg-box'>{t('COMMON.FLIGHT_LEG')}</th>
				<th className='header-cell-allotment flight-no-box'>{t('COMMON.FLIGHT_NO')}</th>
				<th className='header-cell-allotment utilisation-box'>{t('COMMON.UTILISATION')}</th>
			</tr>
			</thead>
			<tbody>
				{allotmentList && allotmentList.length ? (
								allotmentList
									.slice(startIndex, endIndex)
									.map((allotment, index) => (
						<tr id={`allotment-${index}`}>
							<td className='left-table-body-data'>{allotment.allotmentId}</td>
							<td className='left-table-body-data'>{allotment.origin} - {allotment.destination}</td>
							<td className='left-table-body-data'>{allotment.origin} - {allotment.destination}</td>
							<td className='left-table-body-data'>{allotment.flightCarrierCode} {allotment.flightNumber}</td>
							<td className='left-table-body-data-allotment' >
								{allotment.totalVolumePercent &&
								allotment.totalVolumePercent >
									allotment.totalWeightPercent ? (
									<span
										className={getAllotmentColorClass(
											allotment.totalVolumePercent
										)}
									>
										{allotment.totalVolumePercent}%
									</span>
								) : (
									<span
										className={getAllotmentColorClass(
											allotment.totalWeightPercent
										)}
									>
										{allotment.totalWeightPercent}%
									</span>
								)}
							</td>
						</tr>
			))
							) : (
								<></>
							)}
			
				
			
			</tbody>
			</table>
			</div>
			
			<div class="right-section ">
			<table class="right-table">
			<thead>
			<tr>
				<th className="button-cell">
					<button
						className='previous-btn'
						onClick={handlePrev}
						disabled={index === 0}
					>
						<img
							src={leftArrow}
							className='icon-wrapper'
							alt='Previous'
						/>
					</button>
				</th>
				
					{calendarDates && calendarDates.length ? (calendarDates.slice(index, index + 4).map((calendarDate, i) => (
						<th className='header-cell-dates'>
							{calendarDate}
						</th>
					))
				) : (
					<></>
				)}
				<th className="button-cell">
					<button
									className='next-btn'
									onClick={handleNext}
									disabled={disableButton}
								>
									<img src={rightArrow} className='icon-wrapper' alt='Next' />
								</button>
				</th>
			</tr>
			</thead>
			
			<tbody>
  {allotmentList && allotmentList.length ? (
    allotmentList.slice(startIndex, endIndex).map((allotment, altIndex) => (
      <tr key={altIndex}>
        
        <td className="button-cell"></td>

        {calendarDates.slice(index, index + 4).map((calendarDate, calIdx) => {
          const matchingItem = allotment.allotments?.find(
            (item) =>
              moment(item.flightDepartureDate).format('DD MMM') === calendarDate
          );

          return (
            <td key={calIdx} className='button-data'>
              {matchingItem ? (
                allotmentValType === 'allotment-actual' ? (
          //         matchingItem.allotmentPercentVolume >
          //         matchingItem.allotmentPercentWeight ? (
          //           <span
          //             className={`${getAllotmentColorClass(
          //               matchingItem.allotmentPercentVolume
          //             )} ${getActiveColClass(calIdx)}`}
          //           >
          //             {matchingItem.bookedVolume} CBM
          //           </span>
          //         ) : (
          //           <span
          //             className={`${getAllotmentColorClass(
          //               matchingItem.allotmentPercentWeight
          //             )} ${getActiveColClass(calIdx)}`}
          //           >
          //             {matchingItem.bookedWeight} Kg
          //           </span>
          //         )
	 <span
        className={`${getAllotmentColorClass(
          Math.max(
            matchingItem.allotmentPercentWeight,
            matchingItem.allotmentPercentVolume
          )
        )} ${getActiveColClass(calIdx)}`}
      >
        {matchingItem.bookedWeight} / {matchingItem.allotedWeight} Kg
        <br />
        {matchingItem.bookedVolume} / {matchingItem.allotedVolume} m³
      </span>
                ) : matchingItem.allotmentPercentVolume >
                  matchingItem.allotmentPercentWeight ? (
                  <span
                    className={`${getAllotmentColorClass(
                      matchingItem.allotmentPercentVolume
                    )} ${getActiveColClass(calIdx)}`}
                  >
                    {matchingItem.allotmentPercentVolume}%
                  </span>
                ) : (
                  <span
                    className={`${getAllotmentColorClass(
                      matchingItem.allotmentPercentWeight
                    )} ${getActiveColClass(calIdx)}`}
                  >
                    {matchingItem.allotmentPercentWeight}%
                  </span>
                )
              ) : (
                <></>
              )}
            </td>
          );
        })}

        
        <td className="button-cell"></td>
      </tr>
    ))
  ) : (
    <></>
  )}
</tbody>

			</table>
			</div>
			
		</div>
		
				{allotmentList && allotmentList.length !== 0 && (
					<div className='d-none d-lg-block paginationWrapper mt-0 pagination-block'>
						<PaginatorComponent
							currentPage={currentPage}
							pageIndex={pageIndex}
							rowCount={rowCount}
							totalRecords={allotmentList.length}
							onPageIndexChange={onPageIndexChange}
						/>
					</div>
				)}
			

		<div className='d-flex d-lg-none selected-allotment-container'>
			<CommonDropDown
				id='allotmentIdDropdown'
				value={selectedAllotment?.allotmentId || ''}
				options={allotmentOptions}
				label="Select Allotment ID"
				onChange={handleChange}
				
			/>

			 {selectedAllotment && (
			<div className='cargo-details-allotment'>
				<div className='item'>
					<div className='item-header'>{t('CHOOSE_FLT.ORGIN_DESTINATION')}</div>
					<div className='item-value'>{selectedAllotment.origin} - {selectedAllotment.destination}</div>
				</div>
				<div className='item'>
					<div className='item-header'>{t('COMMON.FLT_NO')}</div>
					<div className='item-value'>{selectedAllotment.flightCarrierCode} {selectedAllotment.flightNumber}</div>
				</div>
				<div className='item'>
					<div className='item-header'>{t('DASHBOARD.UTLS')}</div>
					<div className='item-value'>
						{selectedAllotment?.totalVolumePercent &&
						selectedAllotment.totalVolumePercent > selectedAllotment.totalWeightPercent ? (
						<span className={getAllotmentColorClass(selectedAllotment.totalVolumePercent)}>
						{selectedAllotment.totalVolumePercent}%
						</span>
						) : (
						<span className={getAllotmentColorClass(selectedAllotment?.totalWeightPercent)}>
						{selectedAllotment?.totalWeightPercent}%
						</span>
						)}

					</div>
				</div>
			</div>
			 )}

			 <div className='calender-data'>
				<div className='week-day'>
				{calendarDatesMobile.slice(0, 7).map((calendarDate, i) => (
				<div className="calendar-day" key={`weekday-${i}`}>
				{moment(calendarDate, "DD MMM").format("ddd").toUpperCase()}
				</div>
				))}
				</div>

				
				<div className="dates-value-section">
							{/* {weeks.map((week, rowIndex) => (
						<div className="calendar-row-section" key={`row-${rowIndex}`}>
							{allotmentList &&
							allotmentList.slice(startIndex, endIndex).map((allotment, altIndex) =>
								week.map((calendarDatesMobile, i) => {
								const found = allotmentList[selectedAllotment]?.allotments?.find(
								(item) =>
								moment(item.flightDepartureDate).format("DD MMM") === calendarDatesMobile
								);

								return (
								<div className={`calendar-col ${
										found ? 'has-value' : ''
										}`} key={`col-${rowIndex}-${i}`}
									>

								<div className={`day-number ${found ? "has-value" : ""}`}>
									{moment(calendarDatesMobile, "DD MMM").date()}
								</div>
								
								<div className="day-value-red">
									{found
									? allotmentValType === "allotment-actual"
									? found.allotmentPercentVolume > found.allotmentPercentWeight
									? `${found.bookedVolume} CBM`
									: `${found.bookedWeight} Kg`
									: found.allotmentPercentVolume > found.allotmentPercentWeight
									? `${found.allotmentPercentVolume}%`
									: `${found.allotmentPercentWeight}%`
									: ""}
								</div>
								</div>
								);
								})
							)}
								
						</div>
						))} */}
						{weeks.map((week, rowIndex) => (
  <div className="calendar-row-section" key={`row-${rowIndex}`}>
    {week.map((dayString, i) => {
      const found = selectedAllotment?.allotments?.find(
        (item) =>
          moment(item.flightDepartureDate).format("DD MMM") === dayString
      );

      return (
        <div className={`calendar-col ${found ? "has-value" : ""}`} key={`col-${rowIndex}-${i}`}>
          <div className={`day-number ${found ? "has-value" : ""}`}>
            {moment(dayString, "DD MMM").date()}
          </div>

          <div className="day-value-red">
            {found ? (
              allotmentValType === "allotment-actual" ? (
                found.allotmentPercentVolume > found.allotmentPercentWeight ? (
                  `${found.bookedVolume} CBM`
                ) : (
                  `${found.bookedWeight} Kg`
                )
              ) : found.allotmentPercentVolume > found.allotmentPercentWeight ? (
                `${found.allotmentPercentVolume}%`
              ) : (
                `${found.allotmentPercentWeight}%`
              )
            ) : (
              ""
            )}
          </div>
        </div>
      );
    })}
  </div>
))}

						</div>
			 </div>
			

		</div>



			
			
		
		</>
	)
}

export default AllotmentList
